import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import Header from "@/components/layout/Header";
import NewDirectiveDialog from "@/components/NewDirectiveDialog";

export default function AppShell() {
  return (
    <div className="min-h-screen flex bg-surface-muted">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 p-6 grid-backdrop">
          <div className="max-w-[1400px] mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
      <NewDirectiveDialog />
    </div>
  );
}
